if (!customElements.get('pdp-video-testimonials')) {
  customElements.define('pdp-video-testimonials', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pvt__track');
      this.dialog = this.querySelector('.pvt__dialog');
      this.player = this.querySelector('.pvt__popup-player');
      this.slides = [...this.querySelectorAll('.pvt__slide')];
      this.popupIndex = 0;
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const on = (node, event, handler, options = {}) => node?.addEventListener(event, handler, { ...options, signal });

      on(this, 'pointerover', (event) => {
        const slide = event.target.closest('.pvt__slide');
        if (!slide || event.pointerType === 'touch' || slide.contains(event.relatedTarget)) return;
        this.startPreview(slide);
      });
      on(this, 'pointerout', (event) => {
        const slide = event.target.closest('.pvt__slide');
        if (!slide || slide.contains(event.relatedTarget)) return;
        this.stopPreview(slide);
      });
      on(this, 'click', (event) => {
        const open = event.target.closest('.pvt__open');
        if (open && !open.disabled) {
          this.openPopup(Number(open.closest('.pvt__slide').dataset.videoIndex));
          return;
        }
        if (event.target.closest('[data-pvt-track-previous]')) this.moveTrack(-1);
        if (event.target.closest('[data-pvt-track-next]')) this.moveTrack(1);
        if (event.target.closest('[data-pvt-popup-previous]')) this.changePopup(-1);
        if (event.target.closest('[data-pvt-popup-next]')) this.changePopup(1);
        if (event.target.closest('[data-pvt-close]')) this.dialog.close();
      });
      on(this.track, 'scroll', () => this.updateTrack(), { passive: true });
      on(this.track, 'keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.moveTrack(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      on(this.dialog, 'click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      on(this.dialog, 'close', () => this.clearPopup());
      this.resizeObserver = new ResizeObserver(() => this.updateTrack());
      this.resizeObserver.observe(this.track);
      this.updateTrack();
    }
    startPreview(slide) {
      if (matchMedia('(hover: none)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const video = slide.querySelector('.pvt__preview-video');
      if (!video) return;
      this.slides.forEach((item) => { if (item !== slide) this.stopPreview(item); });
      video.muted = true;
      video.play().then(() => slide.classList.add('is-previewing')).catch(() => {});
    }
    stopPreview(slide) {
      const video = slide.querySelector('.pvt__preview-video');
      video?.pause();
      if (video) video.currentTime = 0;
      slide.classList.remove('is-previewing');
    }
    openPopup(index) {
      this.slides.forEach((slide) => this.stopPreview(slide));
      this.popupIndex = index;
      this.renderPopup();
      if (!this.dialog.open) this.dialog.showModal();
    }
    changePopup(direction) {
      this.popupIndex = (this.popupIndex + direction + this.slides.length) % this.slides.length;
      this.renderPopup();
    }
    renderPopup() {
      this.player.querySelector('video')?.pause();
      const template = this.slides[this.popupIndex]?.querySelector('.pvt__template');
      this.player.replaceChildren(template?.content.cloneNode(true) || document.createTextNode(''));
      const video = this.player.querySelector('video');
      if (video) { video.muted = false; video.controls = true; video.play().catch(() => {}); }
    }
    clearPopup() {
      this.player.querySelector('video')?.pause();
      this.player.replaceChildren();
    }
    moveTrack(direction) {
      const first = this.slides[0];
      if (!first) return;
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
      this.track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    updateTrack() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const previous = this.querySelector('[data-pvt-track-previous]');
      const next = this.querySelector('[data-pvt-track-next]');
      if (previous) previous.disabled = this.track.scrollLeft <= 2;
      if (next) next.disabled = this.track.scrollLeft >= max - 2;
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.slides?.forEach((slide) => this.stopPreview(slide));
      this.clearPopup();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
